// Copyright (c) 2020-2024 Omics Data Automation, Inc.
// Copyright (c) 2024 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

export const sendCalendarInvite = async (payload) => {
  try {
    const fetchParams = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + store.getters.jwt,
      },
    }
    const tumorboardId = payload
    const url = `${tumorBoardBaseUrl}/api/v2/invite/${tumorboardId}`
    const response = await fetchWithTimeout(url, fetchParams)
    const result = await response.json()
    if (!result) {
      return result
    }

    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }

  return []
}
